module.exports = __webpack_public_path__ + "img/11_thwi.fa46a5fd.jpg";